/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFactoryPipe: {
  name: 'factory-pipe';
  data: string;
} = {
  name: 'factory-pipe',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 2a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM5 4.5a.5.5 0 0 0-.49.402l-2 10A.5.5 0 0 0 3 15.5h8a.5.5 0 0 0 .49-.598l-2-10A.5.5 0 0 0 9 4.5H5Zm.01 3 .4-2h3.18l.4 2H5.01Zm-.193.965L4.21 11.5h5.58l-.607-3.035A.499.499 0 0 1 9 8.5H5a.499.499 0 0 1-.183-.035ZM3.61 14.5l.4-2h5.98l.4 2H3.61ZM6 3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM7.5 2a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2.5.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM12.5 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z" fill="currentColor"/></svg>`,
};
